<template>
	<div>
		<div id="main" style="text-align: center;">
			正在开发中。。。。。。
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	
	export default {
		data(){
			return {
				token:"",
				charts:'',
				charts2:'',
                opinion:['直接访问','邮件营销','联盟广告','视频广告','搜索引擎'],
                opinionData:[
                  {value:335, name:'直接访问'},
                  {value:310, name:'邮件营销'},
                  {value:234, name:'联盟广告'},
                  {value:135, name:'视频广告'},
                  {value:1548, name:'搜索引擎'}
                ]
			}
		},
		methods:{
			drawPie(id){
				this.charts = echarts.init(document.getElementById(id))
				this.charts.setOption({
					tooltip: {
                   		trigger: 'item',
                   		formatter: '{a}<br/>{b}:{c} ({d}%)'
                 	},
                 	legend: {
	                	orient: 'vertical',
	                   	x: 'left',
	                   	data:this.opinion
	                },
	                series: [
	                   	{
	                    	name:'访问来源',
	                     	type:'pie',
	                     	radius:['50%','70%'],
	                     	avoidLabelOverlap: false,
	                     	label: {
	                       		normal: {
	                         		show: false,
	                         		position: 'center'
	                       		},
	                       		emphasis: {
	                         		show: true,
		                         	textStyle: {
		                           		fontSize: '30',
		                           		fontWeight: 'blod'
		                         	}
	                       		}
	                     	},
	                     	labelLine: {
		                       	normal: {
		                         	show: false
		                       	}
	                     	},
	                     	data:this.opinionData
	                   	}
                 	]
				})
			},
			DrawPie(id){
				this.charts2 = echarts.init(document.getElementById(id))
				this.charts2.setOption({
					title: {
				        text: '折线图堆叠'
				    },
				    tooltip: {
				        trigger: 'axis',
				        axisPointer: {
				            type: 'cross',
				            label: {
				                backgroundColor: '#6a7985'
				            }
				        }
				    },
				    legend: {
				        data:['邮件营销','联盟广告','视频广告','直接访问','搜索引擎'],
				        top:'2%',
				        left:'center'
				    },
				    grid: {
				        left: '3%',
				        right: '3%',
				        bottom: '3%',
				        containLabel: true
				    },
				    toolbox: {
				    	right:'3%',
				        feature: {
				            saveAsImage: {},
//				            restore:{},
//				            dataView:{},
//				            dataZoom:{},
				            magicType: {
						        type: ['line', 'bar', 'stack', 'tiled']
						    }
				        }
				    },
				    xAxis: {
				        type: 'category',
				        boundaryGap: false,
				        data: ['1月','2月','3月','4月','5月','6月','7月']
				    },
				    yAxis: {
				        type: 'value'
				    },
				    series: [
				        {
				            name:'久站',
				            type:'line',
				            stack: '总量',
				            label: {
				                normal: {
				                    show: true,
				                    position: 'top'
				                }
				            },
				            areaStyle: {normal: {}},
				            data:[120, 132, 101, 134, 90, 230, 210]
				        },
				        {
				            name:'急转',
				            type:'line',
				            stack: '总量',
				            label: {
				                normal: {
				                    show: true,
				                    position: 'top'
				                }
				            },
				            areaStyle: {normal: {}},
				            data:[220, 182, 191, 234, 290, 330, 310]
				        },
				        {
				            name:'颠簸',
				            type:'line',
				            stack: '总量',
				            label: {
				                normal: {
				                    show: true,
				                    position: 'top'
				                }
				            },
				            areaStyle: {normal: {}},
				            data:[150, 232, 201, 154, 190, 330, 410]
				        },
//				        {
//				            name:'直接访问',
//				            type:'line',
//				            stack: '总量',
//				            label: {
//				                normal: {
//				                    show: true,
//				                    position: 'top'
//				                }
//				            },
//				            areaStyle: {normal: {}},
//				            data:[320, 332, 301, 334, 390, 330, 320]
//				        },
				        {
				            name:'倾斜提醒',
				            type:'line',
				            stack: '总量',
				            label: {
				                normal: {
				                    show: true,
				                    position: 'top'
				                }
				            },
				            areaStyle: {normal: {}},
				            data:[120, 252, 353, 487, 577, 807, 1017]
				        }
				    ]
				})
			}
		},
		mounted(){
//			this.$nextTick(function() {
//              this.drawPie('main')
//              this.DrawPie('main2')
//          })
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// MessageCenter.vue?278a6500